/* Prime Lending USA — loan estimator
   Informational only. Computes an illustrative monthly range across an APR
   band; never presents a single quoted figure and never implies an offer. */

(function () {
  "use strict";

  var APR_BANDS = {
    personal: { low: 7.0, high: 24.0 },
    business: { low: 8.5, high: 28.0 },
    refi: { low: 6.5, high: 22.5 },
    medical: { low: 7.5, high: 25.0 },
    vehicle: { low: 6.0, high: 21.0 },
    renovation: { low: 7.0, high: 23.5 }
  };

  function formatMoney(value) {
    return "$" + Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function monthlyPayment(principal, annualRate, months) {
    var monthlyRate = annualRate / 100 / 12;
    if (monthlyRate === 0) return principal / months;
    var factor = Math.pow(1 + monthlyRate, -months);
    return (principal * monthlyRate) / (1 - factor);
  }

  function init() {
    var root = document.querySelector("[data-estimator]");
    if (!root) return;

    var amountInput = root.querySelector("[data-estimator-amount]");
    var termInput = root.querySelector("[data-estimator-term]");
    var purposeInput = root.querySelector("[data-estimator-purpose]");
    var amountLive = document.getElementById("EstimatorAmountValue");

    var outAmount = root.querySelector("[data-estimator-out-amount]");
    var outTerm = root.querySelector("[data-estimator-out-term]");
    var outMonthly = root.querySelector("[data-estimator-out-monthly]");
    var note = root.querySelector("[data-estimator-note]");
    var resultPanel = root.querySelector("[data-estimator-result]");

    if (!amountInput || !termInput || !purposeInput) return;

    var update = function (animate) {
      var amount = parseFloat(amountInput.value) || 0;
      var months = parseInt(termInput.value, 10) || 36;
      var band = APR_BANDS[purposeInput.value] || APR_BANDS.personal;

      var low = monthlyPayment(amount, band.low, months);
      var high = monthlyPayment(amount, band.high, months);

      if (amountLive) amountLive.textContent = formatMoney(amount);
      if (outAmount) outAmount.textContent = formatMoney(amount);
      if (outTerm) outTerm.textContent = months + " months";
      if (outMonthly) {
        outMonthly.textContent = formatMoney(low) + " \u2013 " + formatMoney(high);
      }
      if (note) {
        note.textContent =
          "Range shown across an illustrative " +
          band.low.toFixed(1).replace(/\.0$/, "") +
          "% to " +
          band.high.toFixed(1).replace(/\.0$/, "") +
          "% APR band. Informational only \u2014 not an offer.";
      }

      if (animate && resultPanel) {
        resultPanel.classList.remove("is-printed");
        void resultPanel.offsetWidth; /* forced reflow to re-trigger */
        resultPanel.classList.add("is-printed");
      }
    };

    amountInput.addEventListener("input", function () {
      update(true);
    });
    termInput.addEventListener("change", function () {
      update(true);
    });
    purposeInput.addEventListener("change", function () {
      update(true);
    });

    update(false);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
